<template>
  <div class="bg_gray">
    <top-header
      :type="6"
      hasBorder="true"
      placeholder="我的二手房合同"
      fontSize="0.32rem"
    />
    <div class="tab_con fixed m_flex_box flex_hc fixed">
      <span :class="current === 1 ? 'active' : ''" @click="changeType(1)"
        >新版</span
      >
      <span :class="current === 2 ? 'active' : ''" @click="changeType(2)"
        >老版</span
      >
    </div>
    <div class="pad_t"></div>
    <div class="list">
      <van-pull-refresh v-model="isLoading" @refresh="onRefresh">
        <van-list
          v-model="loading"
          :finished="finished"
          finished-text="没有更多了"
          @load="onLoad"
        >
          <div class="no_data" v-if="!list.length">
            <img src="@/assets/img/nodata.png" alt="">
          </div>
          <div v-if="current === 1">
            <div class="inner" v-for="(item, index) in list" :key="index">
              <div class="top m_flex_box flex_vc flex_jz">
                <h4 class="line_comp1">合同号：{{item.contrDateNum}}{{item.contrNum}}</h4>

                <i v-show="item.contrType == 0" class="bg_ori">{{item.contrState | zhStateOnline(item.archive)}}</i>
                <i v-show="item.contrType == 1" class="bg_ori" >{{item.contrState | zhStateOffline}}</i>
                <i v-show="item.contrType == 2" class="bg_ori" >{{item.contrState | zhStateBroker(item.archive)}}</i>
              </div>

              <div class="middle">
                <div class="row">{{item.houseUse}}<i>|</i>{{item.sumArea}}m²<i>|</i>{{item.sumPrice / 10000}}万</div>
                <div class="row_light m_flex_box flex_jz">
                  <p v-if="item.contrType == 0">合同类型：线上合同</p>
                  <p v-if="item.contrType == 1">合同类型：线下合同</p>
                  <p v-if="item.contrType == 2">合同类型：中介合同</p>
                  <p>出卖方：{{item.bargainor}}</p>
                  <p>买受方：{{item.purchaser}}</p>
                </div>
                <div class="row_light">房屋坐落：{{item.houseAddress}}</div>
              </div>
              <div class="btn_con m_flex_box flex_vc flex_he">
                <span @click="toContact(item.id,item.area)">查看合同</span>
              </div>
            </div>
          </div>
          <div v-if="current === 2">
            <div class="inner" v-for="(item, index) in list" :key="index">
              <div class="top m_flex_box flex_vc flex_jz">
                <h4 class="line_comp1">合同号：{{item.contrDateNum}}{{item.contrNum}}</h4>
                <i class="bg_ori">{{item.contrState | underState(item.contrState)}}</i>
                <!--<i class="bg_ori" v-if="item.contrState == 0">已保存</i>
                <i class="bg_ori" v-if="item.contrState == 1">已提交，待审核</i>
                <i class="bg_ori" v-if="item.contrState == 2">审核同意</i>
                <i class="bg_ori" v-if="item.contrState == 3">审核否决</i>
                <i class="bg_gra" v-if="item.contrState == 4">已备案</i>
                <i class="bg_gra" v-if="item.contrState == 5">注销</i>-->
              </div>
              <div class="middle">
                <div class="row">{{item.houseUse}}<i>|</i>{{item.sumArea}}m²<i>|</i>{{item.sumPrice / 10000}}万</div>
                <div class="row_light m_flex_box flex_jz">
                  <p>合同类型：线下合同</p>
                  <p>出卖方：{{item.bargainor}}</p>
                  <p>买受方：{{item.purchaser}}</p>
                </div>
                <div class="row_light">房屋坐落：{{item.houseAddress}}</div>
              </div>
              <div class="btn_con m_flex_box flex_vc flex_he">
                <span @click="toOldContact(item.contrID,item.area)">查看合同</span>
              </div>
            </div>
          </div>
        </van-list>
      </van-pull-refresh>
    </div>
    <van-dialog v-model="show">
      <div class="cover_innr">
        <div class="row m_flex_box flex_vc">
          <p><span>出卖方：</span>{{obj.bargainor}}</p>
          <p><span>证件类别：</span>{{obj.barPassType}}</p>
        </div>
        <div class="row m_flex_box flex_vc">
          <p><span>证件号：</span>{{obj.barPassNo}}</p>
          <p><span>联系电话：</span>{{obj.barPhone}}</p>
        </div>
        <div class="row m_flex_box flex_vc">
          <p><span>买受方：</span>{{obj.purchaser}}</p>
          <p><span>证件类别：</span>{{obj.purPassType}}</p>
        </div>
        <div class="row m_flex_box flex_vc">
          <p><span>证件号：</span>{{obj.purPassNo}}</p>
          <p><span>联系电话：</span>{{obj.purPhone}}</p>
        </div>
        <div class="row m_flex_box flex_vc">
          <p><span>建筑面积：</span>{{obj.sumArea}}㎡</p>
          <p><span>房屋用途：</span>{{obj.houseUse}}</p>
        </div>
        <div class="row m_flex_box flex_vc">
          <p><span>成交总价：</span>{{obj.sumPrice/10000}}万元</p>
          <p><span>所有权证号：</span>{{obj.ownerNo}}</p>
        </div>
        <div class="row_">
          <p><span>土地权证号：</span>{{obj.usuFructNo}}</p>
        </div>
        <div class="row_">
          <p><span>房屋坐落：</span>{{obj.houseAddress}}</p>
        </div>
      </div>
    </van-dialog>
    <slide-img></slide-img>
  </div>
</template>

<script>
let timmer = null;
import qs from 'qs';
import topHeader from '@/components/header';
import slideImg from '@/components/slideImg'
export default {
  data() {
    return {
      current: 1,
      isLoading: false,
      loading: false,
      finished: false,
      list: [],
      timer: null,
      currPageNo: 1,
      show: false,
      obj: {}
    };
  },
  components: {
    topHeader,
    slideImg
  },
  filters: {
    zhStateOnline (value,archive) {
      if (value == '0') {
        return '已保存';
      } else if (value == '1') {
        return '合同已确认';
      } else if (value == '2') {
        return '合同已确认';
      } else if (value == '3'&& !archive) {
        return '交易已确认';
      } else if (value == '3'&&archive==0) {
        return '交易已确认';
      } else if (value == '3'&&archive==1) {
        return '已备案';
      }  else if (value == '4') {
        return '已注销';
      } else {
        return '-'
      }
    },
    zhStateOffline (value) {
      if (value == '0') {
        return '已保存';
      } else if (value == '1') {
        return '已签约';
      } else if (value == '2') {
        return '已上传签字页';
      } else if (value == '3') {
        return '已备案';
      } else if (value == '4') {
        return '已注销';
      } else {
        return '-'
      }
    },

    zhStateBroker (value,archive) {
      if (value == '0') {
        return '已保存';
      } else if (value == '1') {
        return '已签约';
      } else if (value == '2') {
        return '已签约';
      } else if (value == '3' && !archive) {
        return '交易已确认';
      } else if (value == '3' && archive == 0) {
        return '交易已确认';
      } else if (value == '3' && archive == 1) {
        return '已备案';
      } else if (value == '4') {
        return '已注销';
      } else {
        return '-'
      }
    },

    underState (contrState) {
     // var contrState = "-";
      if (contrState == 0) {
        contrState =  '已保存';
      } else if (contrState == 1) {
        contrState =  '已提交，待审核';
      } else if (contrState == 2) {
        contrState =  '审核同意';
      } else if (contrState == 3) {
        contrState =  '审核否决';
      } else if (contrState == 4) {
        contrState =  '已备案';
      } else if (contrState == 5) {
        contrState =  '注销';
      } else {
        contrState =  '错误状态';
      }
      return contrState;
    },
  },

  mounted() {},
  methods: {
    toContact(id,area) {
      this.$router.push({
        path: '/stockContractPic',
        query: {
          id,area
        }
      })
    },


    toOldContact(contrID,area) {
      this.$http.post('cms/wQContract/reg/getWqContractOnline.do', qs.stringify({
        contrID,
        area
      })).then(res => {
        this.show = true;
        this.obj = res.obj.wqContract
      })
    },
    changeType(type) {
      this.current = type;
      this.loading = false;
      this.finished = false;
      this.currPageNo = 1;
      this.$set(this, 'list', []);
      this.onLoad()
    },
    toUrl(path, query){
      this.$router.push({
        path,
        query
      })
    },
    onRefresh() {
      this.loading = false;
      this.finished = false;
      this.currPageNo = 1;
      this.$set(this, 'list', [])
      this.onLoad(1);
    },
    onLoad(type) {
      if(!this.timer){
        this.timer = setTimeout(() => {
          this.timer = null;
        }, 50)
        const URL = this.current === 1 ? 'cms/contractData/reg/getMyOnlineContractData.do' : 'cms/contractData/reg/getMyOnlineContractDataOld.do'
        this.$http({
          url: URL,
          method: 'POST',
          headers: {
            'Content-Type': 'application/json'
          },
          data: {
            offset: (this.currPageNo - 1) * 10,
            pageSize: 10
          }
        }).then(res => {
          if (type) {
            this.isLoading = false;
          }
          if (res.success) {
            this.list = this.list.concat(res.obj.rows);
            this.loading = false;
            this.currPageNo += 1;
          } else {
            this.finished = true;
          }
        })
      }
    }
  },
};
</script>
<style lang="less" scoped>
.cover_innr{
  font-size: 0.24rem;
  .row{
    margin-bottom: 0.2rem;
    p{
      width: 55%;
    }
    p:nth-child(2){
      width: 42%;
    }
  }
  .row_{
    margin-bottom: 0.2rem;
  }
}
/deep/
.van-dialog{
  width: 92%;
  .cover_innr{
    padding: 0.3rem 0.23rem 0;
  }
}
.tab_con {
  height: 0.94rem;
  border-bottom: 1px solid #f5f5f5;
  padding-left: 0.23rem;
  background-color: #fff;
  z-index: 2;

  &.fixed {
    position: fixed;
    top: 0.9rem;
    left: 0;
    right: 0;
  }
  span {
    font-size: 0.32rem;
    color: #202020;
    margin: 0 0.6rem;
    line-height: 0.94rem;
    position: relative;
    &.active {
      font-weight: 800;
      &:after {
        content: "";
        display: block;
        width: 0.48rem;
        height: 0.04rem;
        background-color: #2f72f5;
        position: absolute;
        bottom: 0;
        left: 50%;
        margin-left: -0.24rem;
      }
    }
  }
}
.pad_t {
  padding-top: 0.94rem;
}
.bg_gray{
  background-color: #f5f5f5;
  min-height: 100vh;
}
.inner{
  background-color: #fff;
  padding: 0.3rem 0.23rem 0;
  border-bottom: 0.16rem solid #f5f5f5;
  .top{
    h4{
      font-size: 0.32rem;
      font-weight: 800;
    }
    i{
      padding: 0.02rem 0.04rem;
      color: #fff;
      font-size: 0.2rem;
      text-align: center;
      border-radius: 0.02rem;
      &.bg_ori{
        background-color: #FF5C3C;
      }
      &.bg_gra{
        background-color: #A0A0A0;
      }
    }
  }
  .middle{
    padding: 0.2rem 0 0.1rem;
    border-bottom: 1px solid #f5f5f5;
    font-size: 0.24rem;
    .row{
      margin-bottom: 0.16rem;
      i{
        margin: 0 0.1rem;
      }
    }
    .row_light{
      margin-bottom: 0.16rem;
      color: #666666;
    }
  }
  .btn_con{
    height: 1.08rem;
    padding: 0.25rem 0.23rem;
    box-sizing: border-box;
    span{
      height: 0.58rem;
      width: 1.4rem;
      text-align: center;
      line-height: 0.58rem;
      box-sizing: border-box;
      border: 1px solid #2F72F5;
      color: #2F72F5;
      border-radius: 0.08rem;
      margin-left: 0.14rem;
    }
  }
}
</style>